import axios from 'axios';

export const HTTP = axios.create({
    baseURL: 'https://appadmin.institutoburmannebastos.com.br/api/'
});
